import Plugin from "@ckeditor/ckeditor5-core/src/plugin"
import UnderlineColorEditing from "./underlinecolorediting"
import UnderlineColorUI from "./underlinecolorui"

export default class UnderlineColor extends Plugin {
  static get requires() {
    return [UnderlineColorEditing, UnderlineColorUI]
  }

  static get pluginName() {
    return "UnderlineColor"
  }
}
